module.exports = __webpack_public_path__ + "img/prop-rock-2-right.2ed7a952.png";